import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import colorConfigs from "../../configs/colorConfigs";
import { RouteType } from "../../routes/config";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import SidebarItem from "./SidebarItem";

import minnusimg from './minus.png';
import plusimg from './plus.png';

type Props = {
  item: RouteType;
  openItemId: string | null;
  setOpenItemId: (id: string | null) => void;
};

const SidebarItemCollapse = ({ item, openItemId, setOpenItemId }: Props) => {
  const isOpen = openItemId === item.state; // Check if this item is open

  const { appState } = useSelector((state: RootState) => state.appState);

  useEffect(() => {
    if (appState.includes(item.state)) {
      setOpenItemId(item.state);
    }
  }, [appState, item, setOpenItemId]);

  const handleClick = () => {
    setOpenItemId(isOpen ? null : item.state); // Toggle open state
  };

  return item.sidebarProps ? (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          "&: hover": {
            backgroundColor: colorConfigs.sidebar.hoverBg,
          },
          paddingY: "3px",
          paddingX: "10px",
          paddingBottom: "5px",
          paddingTop: "5px",
        }}
      >
        {isOpen ? (
          <img src={minnusimg} alt="" style={{ width: "13px", marginRight: "12px" }} />
        ) : (
          <img src={plusimg} alt="" style={{ width: "13px", marginRight: "12px" }} />
        )}
        <ListItemText
          primary={
            <Typography
              sx={{
                fontSize: "13px",
                color: colorConfigs.sidebar.color,
                fontFamily: "Open Sans",
              }}
            >
              {item.sidebarProps.displayText}
            </Typography>
          }
        />
      </ListItemButton>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List style={{ paddingBottom: "0px", paddingTop: "0px" }}>
          {item.child?.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <SidebarItemCollapse item={route} openItemId={openItemId} setOpenItemId={setOpenItemId} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ) : null
          )}
        </List>
      </Collapse>
    </>
  ) : null;
};

export default SidebarItemCollapse;
